/** No imports on purpose: sor.evidence.ts reads these labels at load time and a cycle through task.evidence.ts would leave them undefined. */
export enum EvidenceEnforcement {
    Optional = 'Optional',
    RequiredExceptionAllowed = 'RequiredExceptionAllowed',
    RequiredNoExceptions = 'RequiredNoExceptions',
}

export const EVIDENCE_ENFORCEMENT_LABELS: Record<EvidenceEnforcement, string> = {
    [EvidenceEnforcement.Optional]: 'Optional',
    [EvidenceEnforcement.RequiredExceptionAllowed]: 'Required (allow exceptions)',
    [EvidenceEnforcement.RequiredNoExceptions]: 'Required (no exceptions)',
};

/** Shorter than the picker labels because it follows an evidence name in a title (D11.5). */
export const EVIDENCE_ENFORCEMENT_TITLE_LABELS: Record<EvidenceEnforcement, string> = {
    [EvidenceEnforcement.Optional]: '(Optional)',
    [EvidenceEnforcement.RequiredExceptionAllowed]: '(Required, exceptions allowed)',
    [EvidenceEnforcement.RequiredNoExceptions]: '(Required)',
};
